<div class="header w-100">
  <app-header></app-header>
</div>
<div class="container-xxl container-fluid bg-color_white">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>